import { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '../utils'

export interface LinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  underlined?: boolean
}

/** A button element that looks like a link (text with clickable function). */
export default function LinkButton({
  children,
  type = 'button',
  className,
  underlined = true,
  ...props
}: PropsWithChildren<LinkButtonProps>) {
  const classNames = cn(
    'elm-link',
    'text-left',
    { underline: underlined },
    'dark:hover:text-cool-gray-200',
    'dark:focus:text-cool-gray-100',
    className
  )

  return (
    <button type={type} className={classNames} {...props}>
      {children}
    </button>
  )
}
